import React from 'react'
import Popper from '@material-ui/core/Popper'
import '../styles/popper.scss'

const CustomPopper = ({ children, modifiers, className, ...props }) => {
    const [arrowRef, setArrowRef] = React.useState(null)
    return (
        <Popper
            className={`popper${className ? ` ${className}` : ''}`}
            {...props}
            modifiers={{
                ...modifiers,
                arrow: {
                    enabled: true,
                    element: arrowRef,
                },
            }}
        >
            <span className="arrow" ref={setArrowRef} />
            {children}
        </Popper>
    )
}

export default CustomPopper
